module["exports"] = [
  "com",
  "net",
  "biz",
  "ch",
  "de",
  "li",
  "at",
  "ch",
  "ch"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/de_CH/internet/domain_suffix.js
// module id = 2014
// module chunks = 2